import { Typography } from '@platform/elements';

import { Button } from '@website/lib-shared/src/components/blocks/Button/Button.js';
import { LessEquityThanIncidentalCostsHintMessage } from '@website/lib-shared/src/components/moduleWrapper/components/hints/LessEquityIncidentialCost/LessEquityIncidentialCost.js';
import { InsufficientLoanAmountErrorMessageComp } from '@website/lib-shared/src/components/moduleWrapper/components/errors/InsufficientLoanAmountErrorMessageComp.js';
import { LinkComp } from '@website/lib-shared/src/components/blocks/Link/LinkComp.js';
import type { LinkReference } from '@website/lib-shared/src/models/linkReference.js';

import type { RepaymentCalculatorPresetProps } from '../types/RepaymentCalculatorPresetProps.js';

import styles from './createPresetWebsitePartnerInterestRadar.module.scss';

export const createPresetWebsitePartnerInterestRadar = ({
  onOpenModal,
  insufficientLoanAmountLink,
}: {
  onOpenModal: () => void;
  insufficientLoanAmountLink?: LinkReference;
}): RepaymentCalculatorPresetProps => ({
  content: {
    resultDecoration: <ResultDecoration openModal={onOpenModal} />,
    resultAction: <Button onClick={onOpenModal}>Zins-Radar abonnieren</Button>,
    lessEquityThanIncidentalCosts: ({ action }: { action: () => void }) => (
      <LessEquityThanIncidentalCostsHintMessage Link={LinkComp} action={action} />
    ),
  },
  formErrors: {
    insufficientLoanAmount: () => <InsufficientLoanAmountErrorMessageComp link={insufficientLoanAmountLink} />,
  },
});

interface ResultDecorationProps {
  openModal: () => void;
}

const ResultDecoration = ({ openModal }: ResultDecorationProps) => {
  return (
    <div className={styles.subscribeBox}>
      <Typography variant="strong">Aktuellen Zinssatz regelmäßig per E-Mail erhalten</Typography>
      <Button onClick={openModal}>Zins-Radar abonnieren</Button>
    </div>
  );
};
